import axios from '../../../axiosClient.js';

export default async function fetchDailySummary() {
  const res = await axios.get('/api/daily-summary');
  return res.data;
}
